import { FC, memo } from 'react'
import { useEffectOnce, useUpdate } from 'react-use'

import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew'
import { AppBar, Box, IconButton, Toolbar } from '@mui/material'
import { match } from 'ts-pattern'

import { useAppSelector } from '~/app/hooks'
import { Typo } from '~/core/components/alias'
import useAppNavigate from '~/shared/navigation/use-app-navigate'

const ToolbarSide: FC = (props) => <Box flex="1">{props.children}</Box>

const ToolbarMain: FC = (props) => <Box flex="0 0 auto">{props.children}</Box>

const CurrentTitle = memo(() => {
  const update = useUpdate()

  useEffectOnce(() => {
    const $title = document.querySelector('title')
    if (!$title) {
      return undefined
    }
    const obs = new MutationObserver(() => {
      update()
    })
    obs.observe($title, { childList: true, subtree: true })
    return () => obs.disconnect()
  })

  return <>{document.title}</>
})

const ReturnButton = () => {
  const navigate = useAppNavigate()
  const returnButtonBehavior = useAppSelector((state) => state.Ui.returnButtonBehavior)
  const handleClick = () =>
    match(returnButtonBehavior)
      .with('Backup', () => {
        navigate('..', { relative: 'path' })
      })
      .with('Close', () => {
        window.close()
      })
      .exhaustive()

  return (
    <IconButton edge="start" onClick={handleClick}>
      <ArrowBackIosNewIcon />
    </IconButton>
  )
}

const AppHeader = () => (
  <AppBar color="primary" position="sticky" elevation={0}>
    <Toolbar variant="dense">
      <ToolbarSide>
        <ReturnButton />
      </ToolbarSide>
      <ToolbarMain>
        <Typo variant="h6">
          <CurrentTitle />
        </Typo>
      </ToolbarMain>
      <ToolbarSide />
    </Toolbar>
  </AppBar>
)

export default AppHeader
